<div class="main-content">

    <div class="main-container">
        <div class="main-holder-box font-20">

            <h1 class="text-center primary-text mb-5">Terms & Privacy Policy</h1>

            <p class="text-indent text-justify mb-3">My NTRA application (“Application”) owned by National Telecom
                Regulatory
                Authority and its subsidiary services and websites shall be available for your personal use. Your access
                and use
                of this application shall be subject to the following Terms and Conditions of Use and to the laws in
                force in
                the Republic Arab of Egypt Specially law no. 10 year 2003 (Telecommunication Law) and law no. 175 year
                2018
                Egyptian Anti-Cyber and information technology Crimes Law. Furthermore, your access to this Application
                and its
                services shall be deemed to be an unconditional approval of these Terms and Conditions of Use, whether
                or not
                you are a registered user. This approval shall be effective upon your first use of this Application.
                The rules for using the National Telecom Regulatory Authority (NTRA) application apply to all visitors
                and users
                of the Application. The use of the Application may be stopped, prevented and/or terminated in the event
                of a
                violation by the user, or if there are reasons to believe that a user has violated the terms and
                conditions of
                use.</p>

            <p class="text-indent text-justify mb-3">This Privacy Policy describes Our policies and procedures on the
                collection, use and disclosure of Your
                information when You use the Service and tells You about Your privacy rights and how the law protects
                You.</p>

            <p class="text-indent text-justify mb-3">Users are prohibited from violating or attempting to violate the
                procedures and rules in place to protect the Application, for example, but not limited to, the following
                actions:</p>

            <div class="list-area text-justify mb-3">

                <ul>
                    <li>Accessing data that is not intended to be provided to this user, or logging into a server or an
                        account
                        that the user is not authorized to access.
                    </li>
                    <li>Attempting to conduct a test, survey or examination for the aim of exploiting vulnerabilities in
                        NTRA’s
                        system or network, or breaching the security of procedures or documenting them without official
                        permission
                        from NTRA.
                    </li>
                    <li>Attempting to interfere with the service provided to any user, host or network, including, but
                        not limited
                        to, by placing a virus on the Application, increasing the load on it or immersing it, spamming
                        it, or
                        flooding it with emails or disabling it.
                    </li>
                    <li>Sending spam emails to the Application, including promotions, and/or advertisements for products
                        or
                        services; falsifying any Transmission Control Protocol/IP package address or any part of the
                        address
                        information in any email or sending newsgroup messages.
                    </li>
                    <li>Using NTRA’s Application in any way to send e-mail or any matters from the Application or on its
                        behalf or
                        by referring to it or by impersonating its name or description that include insult or offence
                        against the
                        NTRA, its Application or any person, or spreading false news or information and unlawfully
                        attributing to
                        NTRA.
                    </li>
                    <li>Breaching the rules of use and violating the system or network expose the violator to civil and
                        criminal
                        liability. Investigations will be carried out in cases that may involve such violations and
                        breaches, and
                        the perpetrators will be prosecuted.
                    </li>
                    <li>Any act that violates the Egyptian Anti-Cyber and information technology Crimes Law no. 175 year
                        2018 or
                        any other related law in the Arab Republic of Egypt.
                    </li>
                </ul>

            </div>

            <h1 class="text-center primary-text mb-5">Interpretation and Definitions</h1>
            <div class="mt-3 mb-5">

                <h3 class="primary-text pl-2">Interpretation</h3>
                <p class="text-justify ml-4 mb-3">The words of which the initial letter is capitalized have meanings
                    defined under the following conditions. The following definitions shall have the same meaning
                    regardless of whether they appear in singular or in plural.</p>

                <h3 class="primary-text pl-2">Definitions</h3>
                <p class="text-justify ml-4 mb-3">For the purposes of this Privacy Policy:</p>
                <p class="text-justify ml-4 pl-4"><b>Account</b> means a unique account created for You to access our
                    Service or parts of our Service.</p>
                <p class="text-justify ml-4 pl-4"><b>Affiliate</b> means an entity that controls, is controlled by or is
                    under common control with a party, where "control" means ownership of 50% or more of the shares,
                    equity interest or other securities entitled to vote for election of directors or other managing
                    authority.</p>
                <p class="text-justify ml-4 pl-4"><b>Application</b> refers to My NTRA, the software program provided by
                    the Company.</p>
                <p class="text-justify ml-4 pl-4"><b>Company</b> (referred to as either "the Company", "We", "Us" or
                    "Our" in this Agreement) refers to NTRA, Building 4 Km 28 Cairo-Alexandria Desert Road.</p>
                <p class="text-justify ml-4 pl-4"><b>Country</b> refers to: Egypt</p>
                <p class="text-justify ml-4 pl-4"><b>Device</b> means any device that can access the Service such as a
                    cellphone or a digital tablet.</p>
                <p class="text-justify ml-4 pl-4"><b>Personal Data</b> is any information that relates to an identified
                    or identifiable individual.</p>
                <p class="text-justify ml-4 pl-4"><b>Service</b> refers to the Application.</p>
                <p class="text-justify ml-4 pl-4"><b>Service Provider</b> means any natural or legal person who
                    processes the data on behalf of the Company. It refers to third-party companies or individuals
                    employed by the Company to facilitate the Service, to provide the Service on behalf of the Company,
                    to perform services related to the Service or to assist the Company in analyzing how the Service is
                    used.</p>
                <p class="text-justify ml-4 pl-4"><b>Usage Data</b> refers to data collected automatically, either
                    generated by the use of the Service or from the Service infrastructure itself (for example, the
                    duration of a page visit).</p>
                <p class="text-justify ml-4 pl-4 mb-3"><b>You</b> means the individual accessing or using the Service,
                    or the company, or other legal entity on behalf of which such individual is accessing or using the
                    Service, as applicable.</p>
            </div>

            <h1 class="text-center primary-text mb-5">Collecting and Using Your Personal Data</h1>
            <div class="mt-3 mb-5">
                <h3 class="primary-text pl-2">Types of Data Collected</h3>

                <h3 class="primary-text pl-4">Personal Data</h3>
                <p class="text-justify ml-4 pl-6 mb-3">While using Our Service, We may ask You to provide Us with
                    certain personally identifiable information that can be used to contact or identify You. Personally
                    identifiable information may include, but is not limited to:</p>
                <div class="list-area text-justify ml-4 mb-3">
                    <ul>
                        <li>Email Address</li>
                        <li>First name and last name</li>
                        <li>Phone Number</li>
                        <li>Usage Data</li>
                    </ul>
                </div>
                <h3 class="primary-text pl-4">Collection and Use of Location Information</h3>
                <p class="text-justify ml-4 pl-6 mb-3">
                    Our application collects and uses location information from your device with your explicit consent.
                    This includes both foreground and background location data.
                </p>
                <h3 class="primary-text pl-4">Why We Collect Location Information</h3>
                <p class="text-justify ml-4 pl-6 mb-3">We collect location data to provide and improve the quality of our services. 
                    Specifically, we use this data to:
                </p>
                <div class="list-area text-justify ml-4 mb-3">
                    <ul>
                        <li>Generate regulatory quality metrics.</li>
                        <li> Enhance the user experience by providing personalized services based on your location.</li>
                        <li>Improve our services and features.</li>
                    </ul>
                </div>
                <h3 class="primary-text pl-4">How We Collect Location Information</h3>
                <p class="text-justify ml-4 pl-6 mb-3">Our application uses the location services of your device to collect precise location data. When the app is running in the background, it may still collect your location data.
                </p>
                <h3 class="primary-text pl-4">Your Choices</h3>
                <p class="text-justify ml-4 pl-6 mb-3">You have control over your location data. You can enable or disable location services from the settings of your device at any time. However, disabling location services may affect the functionality of the app.
                </p>
                <h3 class="primary-text pl-4">Data Protection</h3>
                <p class="text-justify ml-4 pl-6 mb-3">We are committed to protecting your data. We implement robust security measures to ensure your location data is safe.
                </p>
                <h3 class="primary-text pl-4">Usage Data</h3>
                <p class="text-justify ml-4 pl-6 mb-3">Usage Data is collected automatically when using the Service.</p>
                <p class="text-justify ml-4 pl-6 mb-3">Usage Data may include information such as Your Device's Internet
                    Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You
                    visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and
                    other diagnostic data.</p>
                <p class="text-justify ml-4 pl-6 mb-3">When You access the Service by or through a mobile device, We may
                    collect certain information automatically, including, but not limited to, the type of mobile device
                    You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating
                    system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic
                    data.</p>
                <p class="text-justify ml-4 pl-6 mb-3">We may also collect information that Your browser sends whenever
                    You visit our Service or when You access the Service by or through a mobile device.</p>

                <h3 class="primary-text pl-4">Information Collected while Using the Application</h3>
                <p class="text-justify ml-4 pl-6 mb-3">While using Our Application, in order to provide features of Our
                    Application, We may collect, with Your prior permission:</p>
                <div class="list-area text-justify ml-4 mb-3">
                    <ul>
                        <li>Information regarding your location</li>
                        <li>Information from your Device's phone book (contacts list)</li>
                    </ul>
                </div>

                <p class="text-justify ml-4 pl-6 mb-3">We use this information to provide features of Our Service, to
                    improve and customize Our Service. The information may be uploaded to the Company's servers and/or a
                    Service Provider's server or it may be simply stored on Your device.</p>
                <p class="text-justify ml-4 pl-6 mb-3">You can enable or disable access to this information at any time,
                    through Your Device settings.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Use of Your Personal Data</h3>

                <p class="text-justify ml-4 mb-3">The Company may use Personal Data for the following purposes:</p>
                <p class="text-justify ml-4 pl-4"><b>To provide and maintain our Service,</b> including to monitor the
                    usage of our Service.</p>
                <p class="text-justify ml-4 pl-4"><b>To manage Your Account:</b> to manage Your registration as a user
                    of the Service. The Personal Data You provide can give You access to different functionalities of
                    the Service that are available to You as a registered user.</p>
                <p class="text-justify ml-4 pl-4"><b>For the performance of a contract:</b> the development, compliance
                    and undertaking of the purchase contract for the products, items or services You have purchased or
                    of any other contract with Us through the Service.</p>
                <p class="text-justify ml-4 pl-4"><b>To contact You:</b> To contact You by email, telephone calls, SMS,
                    or other equivalent forms of electronic communication, such as a mobile application's push
                    notifications regarding updates or informative communications related to the functionalities,
                    products or contracted services, including the security updates, when necessary or reasonable for
                    their implementation.</p>
                <p class="text-justify ml-4 pl-4"><b>To provide You</b> with news, special offers and general
                    information about other goods, services and events which we offer that are similar to those that you
                    have already purchased or enquired about unless You have opted not to receive such information.</p>
                <p class="text-justify ml-4 pl-4"><b>To manage Your requests:</b> To attend and manage Your requests to
                    Us.</p>
                <p class="text-justify ml-4 pl-4"><b>For business transfers:</b> We may use Your information to evaluate
                    or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or
                    transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy,
                    liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is
                    among the assets transferred.</p>
                <p class="text-justify ml-4 pl-4 mb-3"><b>For other purposes:</b> We may use Your information for other
                    purposes, such as data analysis, identifying usage trends, determining the effectiveness of our
                    promotional campaigns and to evaluate and improve our Service, products, services, marketing and
                    your experience.</p>

                <p class="text-justify ml-4 mb-3">We may share Your personal information in the following
                    situations:</p>

                <p class="text-justify ml-4 pl-4"><b>With Service Providers:</b> We may share Your personal information
                    with Service Providers to monitor and analyze the use of our Service, to contact You.</p>
                <p class="text-justify ml-4 pl-4"><b>For business transfers:</b> We may share or transfer Your personal
                    information in connection with, or during negotiations of, any merger, sale of Company assets,
                    financing, or acquisition of all or a portion of Our business to another company.</p>
                <p class="text-justify ml-4 pl-4"><b>With Affiliates:</b> We may share Your information with Our
                    affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates
                    include Our parent company and any other subsidiaries, joint venture partners or other companies
                    that We control or that are under common control with Us.</p>
                <p class="text-justify ml-4 pl-4"><b>With business partners:</b> We may share Your information with Our
                    business partners to offer You certain products, services or promotions.</p>
                <p class="text-justify ml-4 pl-4"><b>With other users:</b> when You share personal information or
                    otherwise interact in the public areas with other users, such information may be viewed by all users
                    and may be publicly distributed outside.</p>
                <p class="text-justify ml-4 pl-4 mb-3"><b>With Your consent:</b> We may disclose Your personal
                    information for any other purpose with Your consent.</p>

            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Retention of Your Personal Data</h3>

                <p class="text-justify ml-4 mb-3">The Company will retain Your Personal Data only for as long as is
                    necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data
                    to the extent necessary to comply with our legal obligations (for example, if we are required to
                    retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements
                    and policies.</p>
                <p class="text-justify ml-4 mb-3">The Company will also retain Usage Data for internal analysis
                    purposes. Usage Data is generally retained for a shorter period of time, except when this data is
                    used to strengthen the security or to improve the functionality of Our Service, or We are legally
                    obligated to retain this data for longer time periods.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Transfer of Your Personal Data</h3>

                <p class="text-justify ml-4 mb-3">Your information, including Personal Data, is processed at the
                    Company's operating offices and in any other places where the parties involved in the processing are
                    located. It means that this information may be transferred to — and maintained on — computers
                    located outside of Your state, province, country or other governmental jurisdiction where the data
                    protection laws may differ than those from Your jurisdiction.</p>
                <p class="text-justify ml-4 mb-3">Your consent to this Privacy Policy followed by Your submission of
                    such information represents Your agreement to that transfer.</p>
                <p class="text-justify ml-4 mb-3">The Company will take all steps reasonably necessary to ensure that
                    Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your
                    Personal Data will take place to an organization or a country unless there are adequate controls in
                    place including the security of Your data and other personal information.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Delete Your Personal Data</h3>

                <p class="text-justify ml-4 mb-3">You have the right to delete or request that We assist in deleting the
                    Personal Data that We have collected about You.</p>
                <p class="text-justify ml-4 mb-3">Our Service may give You the ability to delete certain information
                    about You from within the Service.</p>
                <p class="text-justify ml-4 mb-3">You may update, amend, or delete Your information at any time by
                    signing in to Your Account, if you have one, and visiting the account settings section that allows
                    you to manage Your personal information. You may also contact Us to request access to, correct, or
                    delete any personal information that You have provided to Us.</p>
                <p class="text-justify ml-4 mb-3">Please note, however, that We may need to retain certain information
                    when we have a legal obligation or lawful basis to do so.</p>
            </div>

            <h1 class="text-center primary-text mb-5">Disclosure of Your Personal Data</h1>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Business Transactions</h3>

                <p class="text-justify ml-4 mb-3">If the Company is involved in a merger, acquisition or asset sale,
                    Your Personal Data may be transferred. We will provide notice before Your Personal Data is
                    transferred and becomes subject to a different Privacy Policy.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Law enforcement</h3>

                <p class="text-justify ml-4 mb-3">Under certain circumstances, the Company may be required to disclose
                    Your Personal Data if required to do so by law or in response to valid requests by public
                    authorities (e.g. a court or a government agency).</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Other legal requirements</h3>

                <p class="text-justify ml-4 mb-3">The Company may disclose Your Personal Data in the good faith belief
                    that such action is necessary to:</p>
                <div class="list-area text-justify mb-3">
                    <ul>
                        <li>Comply with a legal obligation</li>
                        <li>Protect and defend the rights or property of the Company</li>
                        <li>Prevent or investigate possible wrongdoing in connection with the Service</li>
                        <li>Protect the personal safety of Users of the Service or the public</li>
                        <li>Protect against legal liability</li>
                    </ul>

                </div>

            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Security of Your Personal Data</h3>

                <p class="text-justify ml-4 mb-3">The security of Your Personal Data is important to Us, but remember
                    that no method of transmission over the Internet, or method of electronic storage is 100% secure.
                    While We strive to use commercially acceptable means to protect Your Personal Data, We cannot
                    guarantee its absolute security.</p>
            </div>

            <h1 class="text-center primary-text mb-5">Children's Privacy</h1>

            <p class="text-indent text-justify mb-3">Our Service does not address anyone under the age of 13. We do not
                knowingly collect personally identifiable information from anyone under the age of 13. If You are a
                parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact
                Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without
                verification of parental consent, We take steps to remove that information from Our servers.</p>
            <p class="text-indent text-justify mb-3">If We need to rely on consent as a legal basis for processing Your
                information and Your country requires consent from a parent, We may require Your parent's consent before
                We collect and use that information.</p>


            <div class="mt-3 mb-5">
                <h3 class="primary-text">Using Links to My NTRA application owned by NTRA</h3>

                <p class="text-justify ml-4 mb-3">Application links may not be created or displayed in a popup window or
                    posted
                    on any website, except for service-related links which may be posted on websites whose goals and
                    general
                    policies are consistent with the goals, policies and frameworks of NTRA e-services.</p>

                <p class="text-justify ml-4 mb-3">NTRA shall not in any way be deemed involved in or linked to any trade
                    or
                    service marks, logos or brands or any other means used or appear on some of Application services or
                    any of
                    their contents, unless they are approved by the Commission's competent departments in NTRA.</p>

                <p class="text-justify ml-4 mb-3">NTRA shall reserve full rights to suspend and intercept any links from
                    any
                    unauthorized website or one containing inappropriate, obscene, offensive, indecent, pornographic, or
                    unlawful
                    topics, or any names, materials or information violating any laws or public or private rights.</p>

                <p class="text-justify ml-4 mb-3">NTRA disclaims any responsibility for the contents available on any
                    other
                    website accessed through its own Application or through its services.</p>

            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Property Rights</h3>

                <p class="text-justify ml-4 mb-3">This Application shall be technically supervised by NTRA Centralized
                    Systems
                    Department in the the Arab Republic of Egypt. All the contents of the application, namely services
                    and
                    information, shall be considered as NTRA's property, and shall be fully protected according to the
                    the Arab
                    Republic of Egypt copyright and trademark laws and intellectual property rights.</p>

                <p class="text-justify ml-4 mb-3">Unless otherwise specified, the Application's services and materials
                    may not
                    be sold, licensed, rented, modified, copied, reproduced, reprinted, advertised, transferred,
                    distributed,
                    displayed in public, edited, or used to produce works for public or commercial purposes, without
                    obtaining the
                    prior approval of NTRA, except for scientific, research and awareness-raising purposes, wherein
                    quoting the
                    Application is permissible on condition that its name is provided as reference.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Termination of Use</h3>

                <p class="text-justify ml-4 mb-3">NTRA may, at its absolute discretion, shall has the right terminate,
                    restrict
                    or suspend the user's right to access and use the services offered by the Application without notice
                    and for
                    whatever reason, including violating the terms and conditions of use or any other behavior that the
                    Commission
                    may, at its discretion, deem as illegal or harmful to others. In case of termination, the user shall
                    not be
                    authorized to access or/and Registration to the Application again.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Disclaimer and Limitation of Liability</h3>

                <p class="text-justify ml-4 mb-3">NATIONAL TELECOM REGULATORY AUTHORITY IS NOT RESPONSIBLE, UNDER ANY
                    CIRCUMSTANCES, FOR ANY DIRECT OR INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES, SPECIAL OR
                    EXCEPTIONAL, THAT
                    MAY OCCUR FROM THE USE OF, OR THE INABILITY TO USE, THIS APPLICATION.</p>

                <p class="text-justify ml-4 mb-3">THE E-SERVICES PROVIDED BY NTRA APPLICATION IS END TO END ENCRYPTION
                    AND SHALL
                    ONLY BE INTENDED TO FACILITATE ACCESS TO USER INFORMATION. THEREFORE, THE USER SHALL HEREBY
                    ACKNOWLEDGE BEING
                    FULLY AWARE THAT ONLINE COMMUNICATIONS MAY BE SUBJECT TO INTERFERENCE OR INTERCEPTION BY THIRD
                    PARTIES; THAT
                    THE APPLICATION SHALL NOT REPLACE THE INFORMATION PROVIDED BY OFFICIAL AGENCIES; AND THAT THE
                    REQUESTS AND
                    ADMINISTRATIVE PROCEDURES SHALL BE MADE DIRECTLY BEFORE THE CONCERNED AGENCIES. THEREFORE, ANY
                    REFERENCE TO
                    THIS APPLICATION SHALL BE MADE AT THE USER'S OWN LIABILITY. IN NO WAY SHALL THE COMMISSION ASSUME
                    ANY
                    LIABILITY FOR ANY LOSS OR DAMAGE WHATSOEVER THAT THE USER MAY SUFFER BECAUSE OF USING OR VISITING
                    THE
                    APPLICATION; DEPENDING ON ANY STATEMENT, OPINION OR ADVERTISEMENT ON THE APPLICATION; DELAYING THE
                    OPERATION,
                    LACK OF ACCESS OR BAD CONNECTION TO THE INTERNET; BREAKDOWN OF EQUIPMENT OR SOFTWARE; OR THE CONDUCT
                    OR IDEAS
                    OF ANY PERSON HAVING ACCESS TO THIS APPLICATION. THEREFORE, THE USER SHALL HEREBY ACKNOWLEDGE AND
                    AGREE THAT
                    HIS ONLY WAY TO AVOID ANY DAMAGE OR LOSS THAT MAY HAPPEN AS A RESULT OF HAVING ACCESS OR USE OF THIS
                    APPLICATION IS TO STOP OR DISCONTINUE USING OR ACCESSING IT.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Protection against Viruses</h3>

                <p class="text-justify ml-4 mb-3">NTRA shall exert every possible effort to check and test the contents
                    of the
                    Application. The user shall be required to run anti-virus programs to scan all materials downloaded
                    from the
                    application. NTRA shall not be responsible for any loss, interruption or damage of the user's data
                    and devices
                    that could happen during his use of the Application or any materials downloaded therefrom.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Waiver of Claims</h3>

                <p class="text-justify ml-4 mb-3">My NTRA and the services, information, materials provided or accessed
                    through
                    it shall be provided to the user on "as is" or "as available" basis without any acknowledgements,
                    promises or
                    guarantees whatsoever. NTRA shall not guarantee or assume any liability for any failures, errors or
                    violations
                    that could arise from using this Application or its contents or any other website linked thereto,
                    whether with
                    or without its knowledge.</p>

                <p class="text-justify ml-4 mb-3">The user shall not have the right to own or guarantee the
                    confidentiality of
                    any communications or information that he may send via the services of this Application. Moreover,
                    any use or
                    interactive use that such services involve shall not guarantee any rights, licenses or privileges of
                    any kind
                    to the user.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Compensation</h3>

                <p class="text-justify ml-4 mb-3">The user hereby undertakes that he shall not take any legal action
                    against
                    NTRA or any of its employees or staff in charge of managing, maintaining, updating, or providing
                    Application
                    services. He shall also hold NTRA harmless against any commitments, liabilities and compensations
                    arising from
                    the use of such services, whether the user breaches the terms and conditions of use or violates any
                    of the
                    laws in force in either Egypt or the place where he lives, or otherwise.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Amendment</h3>

                <p class="text-justify ml-4 mb-3">NTRA Shall has the right to make any modification/Amendments to the
                    terms and
                    conditions at any time it wants.</p>

                <p class="text-justify ml-4 mb-3">Any amendment to these terms and conditions shall be effective
                    immediately
                    upon its announcement, unless otherwise indicated. Your continued use of this Application shall be
                    deemed a
                    full acceptance of such amendment.</p>

                <p class="text-justify ml-4 mb-3">Under no circumstances shall any of the Application's contents be
                    modified,
                    the drawings and images on this Application shall be protected by copyright, and they may not be
                    reproduced or
                    exploited in any way whatsoever without obtaining the prior written approval of NTRA</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">External Links Disclaimer</h3>

                <p class="text-justify ml-4 mb-3">Links to other Websites have been included on this Application,
                    considering
                    the needs of the user. NTRA is not responsible for any content on these Websites, nor for anyone's
                    use of them
                    or their work in an appropriate way, or for any problems that may occur from their use.</p>

                <p class="text-justify ml-4 mb-3">The user is solely responsible for all their actions while using any
                    of the
                    Websites that they visit through those links on this Application.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Links on other Websites</h3>

                <p class="text-justify ml-4 mb-3">In order to make information available to the public as broadly as
                    possible,
                    direct linking to all pages hosted on this Application is permitted. However, it is not permitted to
                    upload
                    any pages within separate frameworks on another Website.</p>

                <p class="text-justify ml-4 mb-3">Our Service may contain links to other websites that are not operated
                    by Us. If You click on a third party link, You will be directed to that third party's site. We
                    strongly advise You to review the Privacy Policy of every site You visit.</p>

                <p class="text-justify ml-4 mb-3">We have no control over and assume no responsibility for the content,
                    privacy policies or practices of any third party sites or services.</p>
            </div>


            <div class="mt-3 mb-5">
                <h3 class="primary-text">Changes to this Privacy Policy</h3>
                <p class="text-indent text-justify mb-3">We may update Our Privacy Policy from time to time. We will
                    notify
                    You of any changes by posting the new Privacy Policy on this page.</p>
                <p class="text-indent text-justify mb-3">We will let You know via email and/or a prominent notice on Our
                    Service, prior to the change becoming effective and update the "Last updated" date at the top of
                    this
                    Privacy Policy.</p>
                <p class="text-indent text-justify mb-3">You are advised to review this Privacy Policy periodically for
                    any
                    changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Criteria for Comments of Google Store and App Store and E-Participation</h3>

                <p class="text-justify ml-4 mb-3">Observe public morals, the Egyptian's laws, and avoid using
                    inappropriate phrases or indecent words when he comments on the application and rate the app on
                    Google store or App Store</p>

                <p class="text-justify ml-4 mb-3">Focus on the application updates and keep comments relevant
                    thereto</p>

                <p class="text-justify ml-4 mb-3">Avoid personal criticism that does not enrich the Application</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Judicial Reference</h3>

                <p class="text-justify ml-4 mb-3">The user shall be subject to the judicial laws in the Arab Republic of
                    Egypt.</p>

                <p class="text-justify ml-4 mb-3">NTRA shall have the full right to sue anyone who violates Terms and
                    Conditions and take all the necessary actions against him or her.</p>
            </div>

            <div class="mt-3 mb-5">
                <h3 class="primary-text">Contact Us</h3>
                <p class="text-indent text-justify mb-3">If you have any questions about this Privacy Policy, You can
                    contact us:</p>
                <div class="list-area text-justify mb-3">

                    <ul>
                        <li>By email: myntra@tra.gov.eg</li>
                    </ul>
                </div>
            </div>

            <div class="ml-2 mt-5">
                <p class="lead primary-text">
                    Effective as of May 16, 2023
                </p>

                <p class="lead primary-text">
                    Updated May 16, 2023
                </p>
            </div>


        </div>
    </div>

</div>

